module.exports = __webpack_public_path__ + "media/waves768.46822775.mp4";